
let formData = {
  email: "",
  message: "",
};

const form = document.querySelector(".feedback-form");
const storageKey = "feedback-form-state";
const savedData = localStorage.getItem(storageKey);

if (savedData) {
  formData = JSON.parse(savedData);

  form.elements.email.value = formData.email;
  form.elements.message.value = formData.message;
}

form.addEventListener("input", onInputChange);

function onInputChange(event) {
  const name = event.target.name;
  const value = event.target.value;

  formData[name] = value;

  localStorage.setItem(storageKey, JSON.stringify(formData));
}

form.addEventListener("submit", onFormSubmit);
function onFormSubmit(event) {
    event.preventDefault();

    if (formData.email.trim() === "" || formData.message.trim() === "") {
        alert("Fill please all fields");
        return;
    } else {

        console.log(formData);

        localStorage.removeItem(storageKey);

        formData = {
            email: "",
            message: "",
        };

        form.reset();
    }
}